import api from '../api';

// Aviso de mensalidade em aberto na entrada do app (uma vez por sessão/login).
// O redirecionamento para a Ordem de chegada espera este aviso terminar: `liberado` só resolve
// quando não há mensalidade em aberto ou quando o jogador fecha o pop-up.
const CHAVE = 'rfc_aviso_mensalidade_';

let estado = null; // { userId, pendentes: Promise<[]>, liberado: Promise, liberar }

const jaAvisou = (userId) => {
  try {
    return Boolean(sessionStorage.getItem(CHAVE + userId));
  } catch (e) {
    return false;
  }
};

async function buscarPendentes(userId, token) {
  if (jaAvisou(userId)) return [];
  try {
    // Token explícito: logo após o login ele ainda não foi gravado no localStorage que o `api` lê
    const config = token ? { headers: { Authorization: `Bearer ${token}` } } : undefined;
    const response = await api.get('pagamentos/me', config);
    try {
      sessionStorage.setItem(CHAVE + userId, '1'); // só marca como avisado quando a consulta deu certo
    } catch (e) {
      // ignore
    }
    return (response.data.payments || []).filter((p) => p.status === 'pending' && p.token);
  } catch (e) {
    return [];
  }
}

export function avisoMensalidade(userId, token) {
  if (!estado || estado.userId !== userId) {
    let liberar;
    const liberado = new Promise((resolve) => { liberar = resolve; });
    const pendentes = buscarPendentes(userId, token).then((lista) => {
      if (lista.length === 0) liberar();
      return lista;
    });
    estado = { userId, pendentes, liberado, liberar };
  }
  return estado;
}

// O jogador fechou o pop-up: libera o redirecionamento e os demais avisos.
export function concluirAvisoMensalidade() {
  if (estado) estado.liberar();
}

// No logout: o próximo login volta a verificar e mostrar o aviso.
export function reiniciarAvisoMensalidade() {
  estado = null;
  try {
    Object.keys(sessionStorage).filter((k) => k.startsWith(CHAVE)).forEach((k) => sessionStorage.removeItem(k));
  } catch (e) {
    // ignore
  }
}
